// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUint256 = exports.assertSubtractable = exports.Asset = exports.registerAssetType = exports.ErrUnknownTokenType = exports.ErrValueOutOfBounds = exports.ErrIncompatibleAssets = exports.ErrSubtrahendLargerThanMinuend = exports.ErrUncomparableAssets = exports.TypeTags = exports.requireTokenType = exports.isTokenType = void 0;
const util_1 = require("../../api/util");
const _tokenTypes = ["ETH", "ERC20", "ERC721", "ERC721Mintable"];
function isTokenType(maybeToken) {
    return _tokenTypes.includes(maybeToken);
}
exports.isTokenType = isTokenType;
function requireTokenType(maybeToken) {
    if (!isTokenType(maybeToken))
        throw exports.ErrUnknownTokenType;
    return maybeToken;
}
exports.requireTokenType = requireTokenType;
exports.TypeTags = {
    Amount: "uint",
    Tokens: "idset",
};
exports.ErrUncomparableAssets = new Error("uncomparable assets");
exports.ErrSubtrahendLargerThanMinuend = new Error("subtrahend larger than minuend");
exports.ErrIncompatibleAssets = new Error("incompatible assets");
exports.ErrValueOutOfBounds = new Error("value is not a uint256");
exports.ErrUnknownTokenType = new Error("unkown tokentype");
const assetImpls = new Map();
function registerAssetType(typeTag, valueParser) {
    assetImpls.set(typeTag, valueParser);
}
exports.registerAssetType = registerAssetType;
class Asset {
    static fromJSON(json) {
        for (const key in json) {
            if (assetImpls.has(key)) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return assetImpls.get(key)(json[key]);
            }
            throw new Error(`Asset.fromJSON: invalid key ${key}, obj=${JSON.stringify(json)}`);
        }
        throw new Error(`empty object is not a valid Asset encoding: ${JSON.stringify(json)}`);
    }
    // isCompatible returns whether the assets are of the same type and are thus
    // compatible in Add, Sub and Cmp.
    isCompatible(asset) {
        return this.typeTag() === asset.typeTag();
    }
}
exports.Asset = Asset;
// assertSubtractable asserts that the two given values are substractable. It
// throws an error if this is not the case.
function assertSubtractable(minuend, subtrahend) {
    const res = minuend.cmp(subtrahend);
    if (res === "uncomparable") {
        throw exports.ErrUncomparableAssets;
    }
    else if (res === "lt") {
        throw exports.ErrSubtrahendLargerThanMinuend;
    }
}
exports.assertSubtractable = assertSubtractable;
// assertUint256 asserts, that the given value is in range [0, 2^256-1].
function assertUint256(val) {
    if (!util_1.isUint256(val)) {
        throw exports.ErrValueOutOfBounds;
    }
}
exports.assertUint256 = assertUint256;
//# sourceMappingURL=asset.js.map